import { Link } from "react-router-dom";
import { usePlanState } from "../hooks/usePlanState";
import { openSupport } from "../lib/support";

// Surfaces a failed/overdue payment in-app so the user can fix it before churning.
// Driven by plan-state.payment_past_due (set from the Razorpay payment.failed / halted webhook).
export default function PaymentAlertBanner() {
    const { planState } = usePlanState();
    if (!planState?.payment_past_due) return null;

    return (
        <div className="border-b border-rose-300 dark:border-rose-700/60 bg-rose-50 dark:bg-rose-900/25 text-rose-800 dark:text-rose-200">
            <div className="max-w-6xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm font-medium">
                    ⚠️ Your last payment didn't go through. Update your payment method to keep your plan active.
                </p>
                <div className="flex items-center gap-2">
                    <button onClick={openSupport} className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-rose-400/50 hover:bg-rose-100 dark:hover:bg-rose-900/40">
                        Talk to us
                    </button>
                    <Link to="/settings/billing" className="text-xs font-semibold px-3 py-1.5 rounded-lg bg-rose-600 hover:bg-rose-700 text-white no-underline">
                        Fix payment
                    </Link>
                </div>
            </div>
        </div>
    );
}
